import {connect} from "react-redux";
import CallbackPage from "./CallbackPage";
import * as authActions from "../actions/AuthActions";

function mapStateToProps(state) {
  return {
    authenticated: state.getIn(["auth", "authenticated"])
  }
}

export default connect(mapStateToProps, {...authActions})(CallbackPage);